/** @jsx jsx */
import { jsx } from 'theme-ui'

const WorldCross = ({ fill = 'black', ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 7.3 10"
      width="7.279"
      sx={{
        fill,
        width: ['5px', null, '6px', '7px', '7px'],
        mb: ['0px', null, '-1px', '0px', '0px'],
        mr: 1,
      }}
      {...props}
    >
      <polygon
        points="4.2,5.7 4.2,4.3 7.3,4.3 7.3,3.1 4.2,3.1 4.2,0 4.2,0 3.1,0 3.1,0 3.1,3.1 0,3.1 0,4.3 3.1,4.3 3.1,5.7 0,5.7 
   0,6.9 3.1,6.9 3.1,10 3.1,10 4.2,10 4.2,10 4.2,6.9 7.3,6.9 7.3,5.7 "
      />
    </svg>
  )
}

export { WorldCross }
